/** Dispatch to open the global Bridge Assistant panel (see BridgeAssistantRoot). */
export function openBridgeAssistant() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('mlb-open-bridge-assistant'));
}

export const BRIDGE_ASSISTANT_OPEN_EVENT = 'mlb-open-bridge-assistant';
